import script from "./EmployeeInner.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeInner.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeInner.vue?vue&type=style&index=0&id=3b31e172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b31e172"]])

export default __exports__